import { router } from 'expo-router';
import { Image, Pressable, View } from 'react-native';

import { Text, VStack } from '@squire/ui';

import { routes } from '@/constants/routes';
import { useScreenTranslations } from '@/hooks/useScreenTranslations';
import { Tracker } from '@/utils/tracking';

import { styles } from './styles';
import type { ReferralBannerProps } from './types';

const graphicImage = require('@/assets/images/referral/brand-ambassador.png');

const ReferralBanner = ({
  shopId,
  customerId,
  testID,
}: ReferralBannerProps) => {
  const { t } = useScreenTranslations('ReferralBanner');

  const handlePress = () => {
    Tracker.track('referral_banner_pressed', { shopId, customerId });
    router.push(routes.referral({ shopId, customerId }));
  };

  return (
    <Pressable
      testID={testID}
      onPress={handlePress}
      accessibilityRole="button"
      accessibilityLabel={t('accessibilityLabel')}
      style={({ pressed }) => [styles.banner, pressed && styles.pressed]}
    >
      <VStack style={styles.copy}>
        <View style={styles.pill}>
          <Text variant="sStrong" color="textStatic" style={styles.pillText}>
            {t('eyebrow')}
          </Text>
        </View>
        <Text variant="lStrong" color="textStatic">
          {t('headline')}
        </Text>
      </VStack>
      <View style={styles.graphicSlot}>
        <Image
          testID="referral-banner-graphic"
          source={graphicImage}
          style={styles.graphic}
          resizeMode="contain"
          accessibilityIgnoresInvertColors
        />
      </View>
    </Pressable>
  );
};

ReferralBanner.displayName = 'ReferralBanner';
export { ReferralBanner };
